import * as React from "react";
import { PartyPopper } from "lucide-react";

const isNewYearSeason = (date: Date) => {
  const month = date.getMonth();
  const day = date.getDate();

  if (month === 11) return day >= 28;
  if (month === 0) return day <= 7;
  return false;
};

const NewYearConfettiBurst = () => {
  const shouldRender = React.useMemo(() => isNewYearSeason(new Date()), []);

  if (!shouldRender) return null;

  return (
    <span aria-hidden="true" className="new-year-confetti inline-flex items-center">
      <PartyPopper className="h-4 w-4 text-amber-500" />
    </span>
  );
};

export default NewYearConfettiBurst;
